module.exports = __webpack_public_path__ + "static/media/Size.ab67743a.svg";